import { useRef, useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTextContent,
  DialogTitle,
  Icon,
  PasswordInput,
  Modal,
  RequirementsPopover
} from "@theorgchartdev/storybook";
import { ChangeUserPassword } from "@/Utils/Promises";
import { PasswordChecker } from "./PasswordChecker";
import { kMinPassLength } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const ChangePassModal = props => {
  const { show, setShow } = props;
  const [showPassText, setShowPassText] = useState(false);
  const [newPassInput, setNewPassInput] = useState("");
  const [confirmInput, setConfirmInput] = useState("");
  const [inputError, setInputError] = useState("default");
  const [errorMsg, setErrorMsg] = useState("");

  const openCtrlRef = useRef(null);

  const checker = new PasswordChecker(kMinPassLength);
  const requirementsResult = checker.check(newPassInput);

  const handleChange = e => {
    setNewPassInput(e.target.value);

    const isEmpty = e.target.value === "";
    openCtrlRef.current?.setOpen(!isEmpty);
  };

  const handleBlur = () => {
    openCtrlRef.current?.setOpen(false);
  };

  const TestPasswords = (pass1, pass2) => {
    setInputError("default");

    if (pass1 != pass2) {
      setInputError("error");
      setErrorMsg(`${appstr("passnomatch")}`);
      return false;
    }

    if (pass1.length < kMinPassLength || pass2.length < kMinPassLength) {
      setInputError("error");
      setErrorMsg(
        `${appstr("New password must")} ${appstr("passmin").toLocaleLowerCase()} ${kMinPassLength} ${appstr("passmin2")}`
      );
      return false;
    }

    return true;
  };

  const SavePassword = async () => {
    const testPass = TestPasswords(newPassInput, confirmInput);
    if (testPass) {
      const resp = await ChangeUserPassword(newPassInput);
      if (resp.success) {
        setShow(false);
        setInputError("default");
        setErrorMsg("");
      } else {
        setInputError("error");
        setErrorMsg(resp.message);
      }
    }
  };

  const CancelSavePass = () => {
    setShow(false);
  };

  const commonButtonProps = { size: "medium" };
  const commonInputProps = {
    size: "medium",
    type: showPassText ? "text" : "password",
    status: inputError,
    message: "",
    autoComplete: "new-password"
  };

  return (
    <Modal
      id={"ust-chgpass-modal"}
      show={show}
      maxWidth="medium"
      minWidth="medium"
      onClose={() => {}}
      fullScreen={false}
    >
      <DialogTitle onClose={() => setShow(false)}>
        <span className={"ocn-explorer-icon-label"}>
          <Icon size={"medium"} name={"key"} />
          {appstr("Change password")}
        </span>
      </DialogTitle>
      <DialogContent>
        <DialogTextContent>
          {`${appstr("passmsg")}${kMinPassLength.toString()}${appstr("passmsg2")}`}
        </DialogTextContent>
        <RequirementsPopover
          header={`${appstr("Password must")}:`}
          requirements={requirementsResult}
          openCtrlRef={openCtrlRef}
          reference={
            <PasswordInput
              onBlur={handleBlur}
              onChange={handleChange}
              id={"ust-chgpass-input"}
              dataTestId={"chart-mode-toolbar-change-password-new-input"}
              {...commonInputProps}
              label={appstr("newpass")}
              value={newPassInput}
            />
          }
        />
        <PasswordInput
          id={"ust-chgpass-confirm"}
          dataTestId={"chart-mode-toolbar-change-password-confirm-input"}
          {...commonInputProps}
          label={appstr("Confirm New Password")}
          value={confirmInput}
          onChange={e => setConfirmInput(e.target.value)}
        />
        {errorMsg?.length > 0 ? (
          <span style={{ color: "#721c24", fontWeight: 400 }}>{errorMsg}</span>
        ) : null}
      </DialogContent>
      <DialogActions size="medium">
        <DialogActions.Tertiary
          dataTestId={"chart-mode-toolbar-change-password-cancel"}
          {...commonButtonProps}
          onClick={CancelSavePass}
        >
          {appstr("Cancel").toUpperCase()}
        </DialogActions.Tertiary>
        <DialogActions.Primary
          dataTestId={"chart-mode-toolbar-change-password-save"}
          {...commonButtonProps}
          onClick={SavePassword}
        >
          {appstr("Change password").toUpperCase()}
        </DialogActions.Primary>
      </DialogActions>
    </Modal>
  );
};
